<template>
    <div>
        <DatePicker v-model="values" :format="fmt" :type="type" :placeholder="placeholder" style="width: 100%" @on-change="getValue">
        </DatePicker>
    </div>
</template>

<script>
export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            values: ""
        }
    },


    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        value: {
            type: [String, Array, Number],
            default: ""
        },
        fmt: {
            type: String,
            default: "yyyy-MM-dd"
        },
        type: {
            type: String,
            default: "date"
        },
        placeholder: {
            type: String,
            default: "请选择日期"
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:watch
    // +----------------------------------------------------------------------
    watch: {
        value() {
            this.setValue();
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        setValue() {
            var fmt=this.fmt.toUpperCase();
            if(fmt=="YYYY-MM-DD HH:MM"){
                fmt="YYYY-MM-DD HH:mm"
            };
            
            if (!this.$isblank(this.value)) {
                //时间区间
                if (Array.isArray(this.value)) {
                    if (this.value.length != 2) {
                        this.values = "";
                        this.$msg("存在时间段错误：必须是2个长度的数组", "error");
                    } else {
                        this.values = this.$timeFmt(this.value[0], fmt) + " - " + this.$timeFmt(this.value[1], fmt);
                    };
                };
                //时间
                if (!Array.isArray(this.value)) {
                    this.values = this.$timeFmt(this.value, fmt);
                };
            } else { 
                this.values = "";
            };
        },
        getValue() {
            var getDatePicke = this.getDatePicke(this.values)
            this.$emit("input", getDatePicke);
        },

        // +----------------------------------------------------------------------
        // | Desc:格式化成时间戳
        // +----------------------------------------------------------------------
        getDatePicke(dateStrings) {

            if (!dateStrings) {
                return '';
            };

            if(dateStrings==","){
                return '';
            }

            //不是数组
            if (!Array.isArray(dateStrings)) {
                var date = new Date(dateStrings);
                if (isNaN(date)) {
                    throw new Error('Invalid date string provided: ' + dateString);
                };
                var timestamp = Math.floor(date.getTime() / 1000);
                return timestamp.toString().padStart(10, '0');
            };

            //是数组
            let formattedTimestamps = dateStrings.map(dateString => {
                var date = new Date(dateString);
                if (isNaN(date)) {
                    throw new Error('Invalid date string provided: ' + dateString);
                }
                var timestamp = Math.floor(date.getTime() / 1000);
                return timestamp.toString().padStart(10, '0');
            });
            formattedTimestamps[0]=this.$FMT.toNumber(formattedTimestamps[0]);
            formattedTimestamps[1]=this.$FMT.toNumber(formattedTimestamps[1])+86399;
            return formattedTimestamps;
        }
    }

}
</script>
